import { NgModule } from '@angular/core';
import {
  ExCardWrapperModule,
  ExMainLayoutModule,
  ExMenuModule,
  ExSideBySideModule,
  ExDropdownModule,
  ExSearchModule,
  ExExtendedSearchModule,
  ExComponentLoaderModule,
  ExSidenavModule,
  ExListLayoutModule,
  ExDirectivesModule,
  ExSortModule,
  ExExpandableLabelModule,
  ExFacetsModule,
  EXPipesModule,
  ExComboboxModule,
  ExButtonModule,
  ExChipModule,
  ExPaginationModule,
  ExRightClickActionsModule,
  ExActionMenuModule,
  ExGridLayoutModule,
  ExLinkModule,
  ExEditableTextModule,
  ExScaleModule,
  ExAutocompleteModule,
  ExRecordActionsModule,
  ExSpinnerModule,
  ExThumbnailModule,
  ExIconModule,
  ExProgressBarModule
} from '@exl-ng/core-ui';

@NgModule({
  exports: [
    ExCardWrapperModule,
    ExMainLayoutModule,
    ExMenuModule,
    ExSideBySideModule,
    ExDropdownModule,
    ExSearchModule,
    ExExtendedSearchModule,
    ExComponentLoaderModule,
    ExSidenavModule,
    ExListLayoutModule,
    ExDirectivesModule,
    ExSortModule,
    ExExpandableLabelModule,
    ExFacetsModule,
    EXPipesModule,
    ExComboboxModule,
    ExButtonModule,
    ExChipModule,
    ExPaginationModule,
    ExRightClickActionsModule,
    ExActionMenuModule,
    ExGridLayoutModule,
    ExLinkModule,
    ExEditableTextModule,
    ExScaleModule,
    ExAutocompleteModule,
    ExRecordActionsModule,
    ExSpinnerModule,
    ExThumbnailModule,
    ExIconModule,
    ExProgressBarModule
  ]
})
export class AlmaExUiModule { }
